<script setup lang="ts"></script>

<template>
  <icon name="lucide:refresh-cw" />
</template>

<style scoped></style>
